import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NameInitialsPipe } from '@shared/pipes/name-initials/name-initials.pipe';
import { ErpKeycloakService } from '@shared/services/erp-keycloak/erp-keycloak.service';

@Component({
  selector: 'erp-avatar',
  imports: [NameInitialsPipe],
  templateUrl: './erp-avatar.component.html',
  styleUrl: './erp-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErpAvatarComponent { 
  private readonly keycloak: ErpKeycloakService = inject(ErpKeycloakService)
  public get userName() : string {
      return this.keycloak.getUser()?.firstName!
  }
}
